import React from "react";
import { Icon } from "./Icon";

interface CreditCardProps {
  size?: number;
  className?: string;
  color?: string;
}

export const CreditCardPay2B: React.FC<CreditCardProps> = ({
  size = 16,
  className = "",
  color,
}) => {
  return (
    <Icon size={size} className={className} color={color}>
      <path
        d="M146.158 18.125C88.502 18.125 41.625 64.999 41.625 122.659V174.925H982.426V122.659C982.426 64.999 935.546 18.125 877.894 18.125H146.158ZM982.426 331.725H41.625V645.325C41.625 702.982 88.502 749.856 146.158 749.856H877.894C935.546 749.856 982.426 702.982 982.426 645.325V331.725ZM224.558 540.791H329.092C343.465 540.791 355.225 552.551 355.225 566.925C355.225 581.299 343.465 593.059 329.092 593.059H224.558C210.185 593.059 198.425 581.299 198.425 566.925C198.425 552.551 210.185 540.791 224.558 540.791ZM407.494 566.925C407.494 552.551 419.252 540.791 433.625 540.791H642.694C657.062 540.791 668.826 552.551 668.826 566.925C668.826 581.299 657.062 593.059 642.694 593.059H433.625C419.252 593.059 407.494 581.299 407.494 566.925Z"
        transform="translate(0, 128)"
      />
    </Icon>
  );
};
